"use client";
import { jsx as t } from "react/jsx-runtime";
import { withCmsDataHandling as P } from "../../../handlers/withCmsDataHandling/withCmsDataHandling.js";
import T from "../../layout/Container/Container.js";
import { Button as _, sharedHandler as b } from "@ingeniorforeningen/figurine-core";
import { forwardRef as g } from "react";
import { callToActionDeliveryApiParser as v } from "./CallToAction.helpers.js";
import '../../../assets/CallToAction.css';const w = "_root_818db_2", x = {
  root: w
}, o = g((r, a) => {
  const {
    type: i,
    icon: e,
    fullWidth: n,
    variant: s,
    contrast: l,
    compact: m,
    loading: c,
    text: p,
    disabled: d,
    iconPosition: f,
    className: C,
    wrap: y,
    href: u,
    target: A,
    ...h
  } = r, N = {
    type: i,
    icon: e,
    fullWidth: n,
    variant: s,
    contrast: l,
    compact: m,
    loading: c,
    text: p,
    disabled: d,
    iconPosition: f,
    wrap: y,
    href: u,
    target: A
  };
  return /* @__PURE__ */ t(T, { ref: a, ...h, className: `${x.root} ${C}`, size: "md", children: /* @__PURE__ */ t(_, { ...N }) });
});
o.displayName = "Container";
const D = P({
  Component: b(o),
  deliveryApiParser: v
});
D.displayName = o.displayName;
export {
  x as C,
  o as _CallToAction,
  D as default
};
